<template>
	<div>
		<AppDropdownMenu
			class="app-dropdown-menu"
			v-if="!disabled"
			left
			bottom
			width="200"
			rounded="lg"
			min-width="200"
			max-width="200"
			min-height="120"
			max-height="172"
			:nudge-bottom="26"
			v-model="showMenu"
			:items="menuOptionsToShow"
		>
			<template #activator="{ value }">
				<AnemicButton @click="(e) => e.preventDefault()" class="flex-centerize pa-0" height="25">
					<FeatureVisibilityActivator
						:isOpen="value"
						:isLocked="isLocked"
						:isLoading="isLoading"
						:isVisible="isVisible"
						@click.native="(e) => e.preventDefault()"
						:showStateInActivator="showStateInActivator"
					/>
				</AnemicButton>
			</template>
		</AppDropdownMenu>
		<AppTooltip :text="disabledExplanation" v-else>
			<FeatureVisibilityActivator disabled class="disabled" />
		</AppTooltip>
	</div>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isLockedShareEnabled } from '@/store/modules/featureFlags/getters';
import FeatureVisibilityActivator from '@/components/FeatureVisibility/FeatureVisibilityActivator.vue';
export default {
	name: 'FeatureVisibilityDropdown',
	components: { FeatureVisibilityActivator },
	props: {
		disabled: { type: Boolean },
		isLocked: { type: Boolean },
		isLoading: { type: Boolean },
		isVisible: { type: Boolean },
		allowRemoveAccess: { type: Boolean },
		allowLockVisibility: { type: Boolean },
		showStateInActivator: { type: Boolean },
		disabledExplanation: { type: String, default: 'You do not have permission to change the visibility of this feature' },
	},
	computed: {
		...mapGettersShorthand({ isLockedShareEnabled }),
		availableMenuOptions() {
			return [
				{ text: `Visible`, prependIcon: 'visibility-visible', prependIconWidth: 20, onClick: this.setVisible },
				{
					prependIconWidth: 20,
					text: `Visible - locked`,
					onClick: this.setVisibleLocked,
					prependIcon: 'visibility-visible-locked',
					hide: !this.allowLockVisibility || !this.isLockedShareEnabled,
				},
				{ text: `Hidden`, prependIcon: 'visibility-hidden', prependIconWidth: 20, onClick: this.setHidden },
				{ divider: true, hide: !this.allowRemoveAccess },
				{
					prependIconWidth: 20,
					text: `Remove access`,
					onClick: this.removeAccess,
					hide: !this.allowRemoveAccess,
					prependIcon: 'visibility-remove-access',
				},
			];
		},
		menuOptionsToShow() {
			return this.availableMenuOptions.filter((option) => !option.hide);
		},
	},
	methods: {
		setVisible() {
			this.$emit('set-visible');
		},
		setVisibleLocked() {
			this.$emit('set-visible-locked');
		},
		setHidden() {
			this.$emit('set-hidden');
		},
		removeAccess() {
			this.$emit('remove-access');
		},
		open() {
			this.showMenu = true;
		},
	},
	data() {
		return { showMenu: false };
	},
};
</script>
<style lang="scss" scoped>
.disabled {
	opacity: 0.5;
}
</style>
